import React from "react";

import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { CompanyField, CompanyListField, CompanyAddressField, CompanyLicenseField } from '../../Utilities/Enums/ParametersEnum';
import { ValidityTypeEnum } from '../../Utilities/Enums/ValidityTypeEnums';

export class Company {
    [CompanyField.ADDRESS]: CompanyAddress = new CompanyAddress();
    [CompanyField.CONTACT_PERSON]: string = "";
    [CompanyField.CONTACT_PHONE]: string = "";
    [CompanyField.EMAIL]: string = "";
    [CompanyField.DATABASE]: string | null = null;
    [CompanyField.LICENSE]: CompanyLicense = new CompanyLicense();
    [CompanyField.NAME]: string = "";
    [CompanyField.PUBLIC_ID]: string | number = 0;
    [CompanyField.UPDATED_DATE]?: string | Date | null = null;
    [CompanyField.CREATED_DATE]?: string | Date | null = null;
    [CompanyField.REGISTRATION_CODE]: string = "";
    [CompanyField.VENDOR_PUBLIC_ID]: string | number = 0;
    [CompanyField.VENDOR]: any | null = null;
    [CompanyField.VENDOR_REGISTRATION_CODE]: string = "";
    [CompanyField.IS_ON_PREMISE]: boolean = false;
    [CompanyField.IS_DATABASE_EXIST]: boolean = false;
    [CompanyField.LAST_SYNC_DATETIME]?: string | Date | null = null;
    

    constructor(obj?: Partial<Company>) {
        Object.assign(this, obj);
    }
}

export class CompanyList {
    [CompanyListField.EMAIL]?: string = "";
    [CompanyListField.CONTACT_PERSON]?: string = "";
    [CompanyListField.CONTACT_PHONE]?: string = "";
    [CompanyListField.FULL_ADDRESS]?: string = "";
    [CompanyListField.LICENSE_KEY]?: string = "";
    [CompanyListField.NAME]?: string = "";
    [CompanyListField.PUBLIC_ID]?: string | number = "";
    [CompanyListField.STORAGE_CAPACITY]: number = 0;
    [CompanyListField.STORAGE_USED]: number = 0;
    [CompanyListField.UPDATED_DATE]?: string | Date | null = null;
    [CompanyListField.USER_CAPACITY]: number = 0;
    [CompanyListField.USER_SLOT_USED]: number = 0;
    [CompanyListField.ADDRESS]: CompanyAddress = new CompanyAddress();
    [CompanyListField.REGISTRATION_CODE]?: string = "";
    [CompanyField.VENDOR]: any | null = null;

    constructor(obj?: Partial<CompanyList>) {
        Object.assign(this, obj);
    }
}

export class CompanyAddress {
    [CompanyAddressField.ADDRESS_TYPE]: number = 0;
    [CompanyAddressField.CITY]: string = "";
    [CompanyAddressField.COUNTRY]: string = "";
    [CompanyAddressField.FULL_ADDRESS]: string = "";
    [CompanyAddressField.STATE]: string = "";
    [CompanyAddressField.STREET_ADDRESS]: string = "";
    [CompanyAddressField.ZIP_CODE]: string = "";

    constructor(obj?: Partial<CompanyAddress>) {
        Object.assign(this, obj);
    }
}

export class CompanyLicense {
    [CompanyLicenseField.COMPANY_NAME]?: string = "";
    [CompanyLicenseField.COMPANY_PUBLIC_ID]?: string | number = "";
    [CompanyLicenseField.EXPIRY_DATE]?: string | Date | null = null;
    [CompanyLicenseField.ISSUE_DATE]?: string | Date | null = null;
    [CompanyLicenseField.LICENSE_KEY]?: string = "";
    [CompanyLicenseField.LICENSE_TYPE]: number = 0;
    [CompanyLicenseField.PUBLIC_ID]?: string | number = "";
    [CompanyLicenseField.STATUS]: number = 0;
    [CompanyLicenseField.STORAGE_CAPACITY]: number = 0;
    [CompanyLicenseField.STORAGE_USED]: number = 0;
    [CompanyLicenseField.USER_CAPACITY]: number = 0;
    [CompanyLicenseField.USER_SLOT_USED]: number = 0;
    [CompanyLicenseField.VALIDITY]: number = 0;
    [CompanyLicenseField.VALIDITY_TYPE]: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [CompanyLicenseField.MODULES]?: any = [];

    constructor(obj?: Partial<CompanyLicense>) {
        Object.assign(this, obj);
    }
}

export class CompanyDetailsInterface {
    companyid?: string | number;
    viewType?: ViewType;
    setviewType?: React.Dispatch<React.SetStateAction<ViewType>>;
    setopenDelete?: React.Dispatch<React.SetStateAction<boolean>>;
    setdeleteType?: React.Dispatch<React.SetStateAction<string>>;
    settoDeleteItem?: React.Dispatch<React.SetStateAction<any>>;
    previewData?: Company;
    formData?: Company;
    setformData?: React.Dispatch<React.SetStateAction<Company>>;
    errorMessages?: any;
    setErrorMessages?: React.Dispatch<React.SetStateAction<any>>;
    DropdownData?: any;
    reinitializeData?: boolean;
    setreinitializeData?: React.Dispatch<React.SetStateAction<boolean>>;
    getCompanyData?: () => void = () =>{};
}

export class RenewLicenseModalInterface {
    openRenewLicenseModal?: boolean;
    setopenRenewLicenseModal?: React.Dispatch<React.SetStateAction<boolean>>;
    companyPublicId?: string | number;
    getCompanyData?: () => void = () =>{};


    constructor(obj?: Partial<RenewLicenseModalInterface>) {
        Object.assign(this, obj);
    }
}

